import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import { Analytics } from '@vercel/analytics/react'
import Header from './components/Header'
import Footer from './components/Footer'
import HomeScreen from './screens/HomeScreen'
import CVPage from './screens/CVPage'
import CompetencesPage from './screens/CompetencesPage'
import PublicationsPage from './screens/PublicationsPage'
import HonorsPage from './screens/HonorsPage'
import ContactsPage from './screens/ContactsPage'
import BlogScreen from './screens/BlogScreen'
import PostDetailScreen from './screens/PostDetailScreen'
import ReadLaterScreen from './screens/ReadLaterScreen'
import UnsubscribeScreen from './screens/UnsubscribeScreen'
import './App.css'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function TrackPageView() {
  const { pathname } = useLocation()
  const isFirst = useRef(true)
  useEffect(() => {
    if (isFirst.current) { isFirst.current = false; return }
    fetch('/api/visit/', { method: 'POST' })
  }, [pathname])
  return null
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <TrackPageView />
      <Header />
      <main>
        <Routes>
          <Route path='/' element={<HomeScreen />} />
          <Route path='/cv/' element={<CVPage />} />
          <Route path='/competences/' element={<CompetencesPage />} />
          <Route path='/publications/' element={<PublicationsPage />} />
          <Route path='/honors/' element={<HonorsPage />} />
          <Route path='/contacts/' element={<ContactsPage />} />
          <Route path='/blog/' element={<BlogScreen />} />
          <Route path='/blog/saved/' element={<ReadLaterScreen />} />
          <Route path='/blog/unsubscribe/:token/' element={<UnsubscribeScreen />} />
          <Route path='/blog/:slug/' element={<PostDetailScreen />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />
    </Router>
  )
}

export default App
